import {
    Typography,
    Avatar,
    Button,
    useMediaQuery
    } from '@material-ui/core';
import { useProfileStyles } from '../../styles/muiStyles';
import { useAuthContext } from '../../context/auth';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import { useApolloClient } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
    

const Profile = () => {
    const classes = useProfileStyles();
    const { user, logoutUser } = useAuthContext();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  
    const client = useApolloClient();
    const history = useHistory();

    const handleLogout = () => {
        client.clearStore();
        logoutUser();
        history.push('/login');
    };

        return (
            <div>
                <div className={classes.topPart}>
                    {!user.imageURL ? 
                        <Avatar
                        src={`https://avatars.dicebear.com/api/initials/${user.initial}.svg?backgroundColorLevel=300&fontSize=35`}
                        className={`${isMobile ? classes.avatarMobile : classes.avatarDesktop}`}
                        />
                        :
                        <Avatar
                        alt={user.fullName}
                        src={user.imageURL}
                        className={`${isMobile ? classes.avatarMobile : classes.avatarDesktop}`}
                        />
                    }
                    <div className={classes.text}>
                        <Typography color="secondary" variant="h5">
                            {user.fullName}
                        </Typography>
                        <Typography color="secondary" variant="body1">
                            {user.email}
                        </Typography>
                        <Typography color="secondary" variant="body1">
                        {user.role==='student' ? 'Student': user.role==='studentAdmin' ? 'Student Admin': user.role==='faculty' ? 'Faculty':
                        user.role==='Admin' ? 'Admin': ''}
                        </Typography>
                    </div>
                    <Button 
                        color="primary"
                        variant="contained"
                        size="small"
                        className={classes.logoutBtn}
                        onClick={handleLogout}
                        startIcon={<PowerSettingsNewIcon />}
                    >
                        Logout
                    </Button>
                </div>
            </div>
        );
    };

    export default Profile;
